import Typography from '../../sharedComponents/Typography/Typography';
import styles from './home-authed.module.scss';

const WeatherAssurance: React.FC = () => (
  <aside className={styles.assuranceCard}>
    <div className={styles.assuranceIcon} aria-hidden="true">
      <span className={styles.assuranceCloud} />
      <span className={styles.assuranceDrop}>●</span>
    </div>
    <div>
      <Typography variant="label-1" className={styles.assuranceTitle}>
        WE WATCH THE WEATHER
      </Typography>
      <Typography variant="body-2">
        If covered weather disrupts your plans, Sensible Weather will email you
        with instructions to collect your payout.
      </Typography>
    </div>
  </aside>
);

export default WeatherAssurance;
